import { Button, Form, Input, Modal, Select, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../../../../nestserver";
import StudentFeDetails from "../../../../admin/pages/components/managefee/StudentFeeDetails";
import ViewTransactionHistory from "../../../../admin/pages/components/managefee/ViewTransactionHistory";

const ViewFeeDetails = () => {
  const getCurrentAcademicYear = () => {
    const today = new Date();
    const curYear = today.getFullYear();
    const curMonth = today.getMonth() + 1;
    const startYear = curMonth >= 6 ? curYear : curYear - 1;
    const endYearShort = String(startYear + 1).slice(-2);
    return `${startYear}-${endYearShort}`;
  };

  const academicYears = [getCurrentAcademicYear()];

  const [form] = Form.useForm();
  const { Option } = Select;
  const isParent = true;
  const [openTransactionHistory, setOpenTransactionHistory] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState();
  const [selectedStudentId, setSelectedStudentId] = useState();
  const [selectedStudentResponse, setSelectedStudentResponse] = useState([]);
  const [year, setYear] = useState(getCurrentAcademicYear());
  const [isYear, setIsYear] = useState(true);

  // -- Online payment (Razorpay) — disabled for now, kept for future re-enable --
  // const [payForm] = Form.useForm();
  // const [OpenTransactionPopup, setOpenTransactionPopup] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [feeRefreshKey, setFeeRefreshKey] = useState(0);

  const handleYearChange = (value) => {
    setYear(value);
    setIsYear(!!value);
  };

  async function fetchStudent() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/students/by-parent/`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data.result;
  }
  const students = useQuery("students/by-parent", fetchStudent);

  const handleSelectChange = (studentId) => {
    if (studentId) {
      setSelectedStudentId(studentId);
      form.setFieldsValue({ name: studentId });

      const fetchClassStudents = async () => {
        if (year) {
          const res = await axios({
            method: "get",
            url: `${serverUrl}/student-fee/${studentId}?year=${year}`,
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem(
                "jwt-token",
              )}`,
            },
          });
          return res.data;
        }
      };
      fetchClassStudents()
        .then((response) => {
          form.resetFields(["studentId", "class", "parent", "phone"]);

          setSelectedStudentResponse(response?.result);
          form.setFieldsValue({
            studentId: response?.result?.[0]?.student?.unique_id,
            class: response?.result?.[0]?.class?.name,
            parent: `${response?.result?.[0]?.student?.parent?.first_name} ${response?.result?.[0]?.student?.parent?.last_name}`,
            phone: response?.result?.[0]?.student?.parent?.phone,
          });
        })
        .catch((err) => {
          message.error(err?.response?.data?.error?.errors);
          form.resetFields(["studentId", "class", "parent", "phone"]);
          setSelectedStudentResponse();
        });
    }
  };
  // Default to the first student once the list loads, so the fee details
  // show up immediately instead of requiring a manual selection.
  useEffect(() => {
    if (year && students?.data?.length > 0 && !selectedStudentId) {
      handleSelectChange(students.data[0]._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [students?.data]);

  useEffect(() => {
    if (!isYear) {
      setSelectedStudentResponse();
      form.resetFields(["name", "studentId", "class", "parent", "phone"]);
    }
  }, [form, isYear]);

  const currentFeeStudentId = selectedStudentResponse?.[0]?.student?._id;

  useEffect(() => {
    if (!currentFeeStudentId) return;

    const fetchStudentFeeHistory = async () => {
      try {
        const res = await axios({
          method: "get",
          url: `${serverUrl}/student-fee/${currentFeeStudentId}/transaction-history`,
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        });
        setTransactionHistory(res.data?.result);
      } catch (error) {
        console.error("Error fetching student fee history:", error);
      }
    };

    fetchStudentFeeHistory();
  }, [currentFeeStudentId]);

  /* -- Online payment (Razorpay) — disabled for now, kept for future re-enable --
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async (values) => {
    setLoading(true);
    const res = await loadRazorpayScript();

    if (!res) {
      message.error("Razorpay SDK failed to load. Are you online?");
      setLoading(false);
      return;
    }

    try {
      const { amount, notes } = values;
      const studentData = selectedStudentResponse?.[0];
      const studentId = studentData?.student?._id;
      const schoolId = studentData?.school;

      const orderRes = await axios({
        method: "post",
        url: `${serverUrl}/payment-gateway/order`,
        data: {
          amount: Number(amount) * 100, // Convert to paise
          currency: "INR",
          studentId: studentId,
          schoolId: schoolId,
          notes: {
            info: notes || "Online Fee Payment",
            student_name: `${studentData?.student?.first_name} ${studentData?.student?.last_name}`,
            class: studentData?.class?.name,
          },
        },
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      });

      const orderData = orderRes.data;

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: orderData.amount,
        currency: orderData.currency,
        name: studentData?.student?.school?.name || "Is-Kool Junior",
        description: `Fee Payment for ${studentData?.student?.first_name}`,
        order_id: orderData.id,
        handler: async function (response) {
          try {
            await axios({
              method: "post",
              url: `${serverUrl}/payment-gateway/verify`,
              data: {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              },
              headers: {
                Authorization: `Bearer ${window.localStorage.getItem(
                  "jwt-token",
                )}`,
              },
            });
            message.success("Payment Successful!");
            setOpenTransactionPopup(false);
            payForm.resetFields();

            // Refresh data
            const studentId = selectedStudentResponse?.[0]?.student?._id;
            if (studentId && year) {
              const res = await axios({
                method: "get",
                url: `${serverUrl}/student-fee/${studentId}?year=${year}`,
                headers: {
                  Authorization: `Bearer ${window.localStorage.getItem(
                    "jwt-token",
                  )}`,
                },
              });
              setSelectedStudentResponse(res.data?.result);
              // Force StudentFeDetails to re-fetch its summary data
              setFeeRefreshKey((k) => k + 1);

              // Refresh history
              const historyRes = await axios({
                method: "get",
                url: `${serverUrl}/admin/student-fee/${studentId}/transaction-history`,
                headers: {
                  Authorization: `Bearer ${window.localStorage.getItem(
                    "jwt-token",
                  )}`,
                },
              });
              setTransactionHistory(historyRes.data?.result);
            }
          } catch (err) {
            message.error(
              "Payment verification failed. Please contact support.",
            );
            console.error(err);
          }
        },
        prefill: {
          name: `${studentData?.student?.first_name} ${studentData?.student?.last_name}`,
          contact: studentData?.student?.parent?.phone,
        },
        theme: {
          color: "#EF4444",
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      console.error(error);
      message.error(error?.response?.data?.message || "Order creation failed.");
    } finally {
      setLoading(false);
    }
  };
  */

  return (
    <div className="student-form-fee">
      <div className="p-8">
        <div className="bg-white p-10 rounded-2xl">
          <div className="text-2xl text-orange-500 font-semibold pb-4">Fee</div>
          <Form
            layout="vertical"
            name="basic"
            form={form}
            initialValues={{ remember: true, year: getCurrentAcademicYear() }}
            autoComplete="off"
          >
            <div className="form-grid">
              <Form.Item
                label="Year"
                name="year"
                rules={[
                  {
                    required: true,
                    message: "Please select year!",
                  },
                ]}
              >
                <Select
                  placeholder="Select year"
                  onChange={handleYearChange}
                  className="w-full"
                >
                  {academicYears.map((yr) => (
                    <Option key={yr} value={yr}>
                      {yr}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {year && isYear && (
                <>
                  <Form.Item label="Name" name="name">
                    <Select
                      showSearch
                      showArrow
                      placeholder="Select name"
                      className="w-full bg-gray-300"
                      style={{
                        border: "6px",
                        backgroundColor: "#EBEBEB",
                      }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      onChange={(value) => handleSelectChange(value)}
                    >
                      {students &&
                        students?.data?.map((data) => {
                          return (
                            <Option key={data._id} value={data._id}>
                              {`${data?.first_name} ${data?.last_name}`}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                  <Form.Item label="Student Id" name="studentId">
                    <Input readOnly />
                  </Form.Item>
                </>
              )}
            </div>
            {year && isYear && (
              <div className="form-grid">
                <Form.Item label="Class" name="class">
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="Parent" name="parent">
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="Phone" name="phone">
                  <Input readOnly />
                </Form.Item>
              </div>
            )}
          </Form>

          <div className="flex justify-end pt-5 items-center gap-4">
            {/* {selectedStudentResponse &&
              selectedStudentResponse.length > 0 &&
              selectedStudentResponse[0].remaining > 0 && (
                <Button
                  type="primary"
                  className="flex items-center justify-center gap-3 h-10 px-6 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 border-none rounded-lg shadow-md hover:shadow-lg transition-all duration-300 font-medium"
                  icon={<HiCurrencyRupee size={20} />}
                  onClick={() => {
                    setOpenTransactionPopup(true);
                  }}
                >
                  Pay Online
                </Button>
              )} */}
            <Button
              className="flex items-center justify-center gap-2 h-10 px-6 rounded-lg border-gray-300 hover:text-orange-500 hover:border-orange-500 transition-all duration-300 font-medium"
              onClick={() => {
                setOpenTransactionHistory(true);
              }}
            >
              View History
            </Button>
          </div>
          <div>
            <StudentFeDetails
              feeResponse={isYear && selectedStudentResponse}
              isParent={isParent}
              classId={isYear && selectedStudentResponse?.[0]?.class?._id}
              studentId={isYear && selectedStudentResponse?.[0]?.student?._id}
            />
          </div>
        </div>
      </div>

      {/* <Modal
        width={400}
        title="Make Payment"
        visible={OpenTransactionPopup}
        onCancel={() => {
          setOpenTransactionPopup(false);
          payForm.resetFields();
        }}
        footer={null}
      >
        <Form form={payForm} layout="vertical" onFinish={handlePayment}>
          <div className="bg-blue-50 p-3 rounded-lg flex items-start gap-2 mb-4 text-blue-700 text-sm">
            <AiOutlineInfoCircle size={20} className="mt-0.5 flex-shrink-0" />
            <span>
              You are about to make a secure online payment via Razorpay.
            </span>
          </div>

          <Form.Item
            label="Amount (INR)"
            name="amount"
            rules={[{ required: true, message: "Please enter amount" }]}
          >
            <Input type="number" prefix="₹" min={1} />
          </Form.Item>

          <Form.Item label="Notes (Optional)" name="notes">
            <Input.TextArea rows={2} placeholder="e.g. Tuition Fee Term 1" />
          </Form.Item>

          <div className="flex justify-end gap-3 mt-6">
            <Button onClick={() => setOpenTransactionPopup(false)}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="bg-orange-500 hover:bg-orange-600 border-none"
            >
              Pay Now
            </Button>
          </div>
        </Form>
      </Modal> */}
      <Modal
        width={1300}
        layout="vertical"
        visible={openTransactionHistory}
        onOk={() => setOpenTransactionHistory(false)}
        onCancel={() => {
          setOpenTransactionHistory(false);
        }}
        footer={null}
      >
        <ViewTransactionHistory
          transactionHistory={isYear && transactionHistory}
          studentId={selectedStudentResponse?.[0]?.student?._id}
        />
      </Modal>
    </div>
  );
};

export default ViewFeeDetails;
